/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/modals/Modal';

import { withTranslation } from 'language/i18n';
import useTimerHandler from 'pages/machinery/hooks/useTimerHandler';
import LeftSide from './sides/LeftSide';
import MakeBidSide from './sides/MakeBidSide';
import PayDepositSide from './sides/PayDepositSide';

const MarketPlaceModal = ({
  visible, setVisible, offers, setCheckBidModalData, machine, setHowToAuctionWorkModalVisible, minimumIncrement, user,
}) => {
  const { timeLeft } = useTimerHandler({ machine });

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
    >
      <div className="modal-content modal-transparent">
        <div className="modal-body p-0">
          <div className="row">
            <LeftSide
              machine={machine}
              timeLeft={timeLeft}
            />
            {
              user.depositBalance > 0
                ? (
                  <MakeBidSide
                    setVisible={setVisible}
                    offers={offers}
                    setCheckBidModalData={setCheckBidModalData}
                    setHowToAuctionWorkModalVisible={setHowToAuctionWorkModalVisible}
                    machine={machine}
                    minimumIncrement={minimumIncrement}
                  />
                )
                : (
                  <PayDepositSide
                    offers={offers}
                    machine={machine}
                    minimumIncrement={minimumIncrement}
                  />
                )
            }
          </div>
          <div className="row mt-4 mb-4">
            <div className="col">
              <div className="separator separator--horizontal" />
            </div>
          </div>
          <div className="row">
            <div className="col-auto">
              <i className="fa-solid fa-info-circle text-white fs-22" />
            </div>
            <div className="col">
              <div className="text-white fs-12 fw-700">
                <p>
                  Verilen teklifler, teklif verenin sorumluluğundadır ve bağlayıcıdır.
                </p>
                <p>
                  Verilen teklifi geri almak veya caymak mümkün değildir. Teklifiniz, açık artırmayı
                  kazanan teklif olduğu takdirde makinayı satın almayı kabul etmiş olursunuz.
                  Açık artırmasını kazandığınız iş makinasını satın almaktan vazgeçerseniz teminat
                  bedeli iade alma hakkını kaybedersiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

MarketPlaceModal.propTypes = {
  visible: PropTypes.object,
  setVisible: PropTypes.func,
  machine: PropTypes.object,
  setCheckBidModalData: PropTypes.func,
  offers: PropTypes.array,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  minimumIncrement: PropTypes.number,
  user: PropTypes.object,
};

export default withTranslation('common')(MarketPlaceModal);
